// things used in both the FlowObjectTeamList component and its child components


class RoleOrGroupDisplay {
    // normalized class for both ObjectRole and TeamManagerObjectRoleGroup for common display purposes
    // we follow the schema of the already-normalized role or group from TeamManagerObjectRole/GroupConfig
    // although some attrs are missing for roles or groups... so we need defaults here
    // but if we are making from ObjectRole, we transform things to match
    constructor({role_or_group, is_collapsible, start_collapsed, unique_key, name, description, role_slug, add_trigger, remove_trigger, can_add, can_remove, tenant_users, empty_text, hide_if_empty, roles}) {
        this.role_or_group = role_or_group;  // 'role' or 'group'
        this.is_collapsible = is_collapsible ?? false;  // only applicable for groups
        this.start_collapsed = start_collapsed ?? false;  // only applicable for groups
        this._isCollapsed = start_collapsed ?? false;  // the current collapsed state - only for groups
        // below is the stuff we always have on an ObjectRole
        this.unique_key = unique_key;  // unique_key for teamManagerData, id for ObjectRole
        this.name = name;  // common for both
        this.description = description || '';  // common for both
        this.role_slug = role_slug || '';  // does not exist for groups
        // below is the extra stuff we add for local functionality and display
        this.add_trigger = add_trigger || '';  // string trigger name for adding this role, IF available
        this.remove_trigger = remove_trigger || '';  // string trigger name for removing this role, IF available
        this.can_add = can_add && !!this.add_trigger;  // boolean if current TU can add this role - passed in, but not possible if trigger is empty
        this.can_remove = can_remove && !!this.remove_trigger;  // boolean if current TU can remove this role
        this.tenant_users = tenant_users;  // array of tenant_user objects
        this.empty_text = empty_text || '';  // string to show if no TUs in this role/group
        this.hide_if_empty = hide_if_empty ?? false;  // groups and roles???
        this.roles = roles ?? null;  // children roles, applicable for groups, keep null otherwise -- you should pass through your normalizer function before passing in here (only one layer of nesting is possible)
    }
}

const makeDisplayFromTeamManagerRole = (roleData) => {
    // the structure for roles in the TeamManagerData is different from ObjectRole
    // it is already mostly normalized, doens't have all the same attrs as groups, but we have defaults for them
    // we could probably just feed the object to the constructor directly.... but we'll explicitly set a couple things
    return new RoleOrGroupDisplay({
        ...roleData,
        role_or_group: 'role',  // just to be explicit
        can_add: !!roleData.add_trigger,
        can_remove: !!roleData.remove_trigger,
    });
};

const makeDisplayFromTeamManagerGroup = (groupData) => {
    // the structure for groups in the TeamManagerData is already mostly normalized
    // doens't have all the same attrs as roles, but we have defaults for them
    // const { is_collapsible, start_collapsed, ...restGroupData } = groupData;  // eslint-disable-line no-unused-vars
    // actually, we can pass it all down so child knows if it is collapsible or not
    return new RoleOrGroupDisplay({
        ...groupData,
        role_or_group: 'group',  // just to be explicit
        can_add: false,
        can_remove: false,
        roles: groupData.roles ? groupData.roles.map(makeDisplayFromTeamManagerRole) : null,  // normalize children roles if present
    });
};


export {
    RoleOrGroupDisplay,
    makeDisplayFromTeamManagerRole,
    makeDisplayFromTeamManagerGroup,
}